<template>
  <v-col>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="rdsUsers"
      item-key="username"
      class="elevation-1"
      fixed-header
      show-select
      :items-per-page="-1"
      disable-pagination
      hide-default-footer
      height="600px"
    >
      <v-divider inset />
      <template #top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            Gewählte User: {{ form ? selected.length : 0 }}/{{ getRdsUserCount }}
          </v-toolbar-title>
        </v-toolbar>
      </template>
      <template #[`item.branch_id`]="{ item }">
        {{ branchname(item.branch_id) }}
      </template>
      <template #no-data>
        Bitte füllen Sie zunächst die vorherige Frage aus.
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
export default {
   name: 'RDSUsers',
   inject: ['companyUsers', 'branchItems', 'userCount', 'rdsUserCount'],
   model: {
      prop: 'form',
      event: 'update:form',
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Array,
         required: true,
      },
   },

   data () {
      return {
         headers: [
            { text: 'Vorname', value: 'firstname' },
            { text: 'Nachname', value: 'lastname' },
            { text: 'Benutzername', value: 'username' },
            { text: 'Standort', value: 'branch_id' },
            { text: 'E-Mail', value: 'email' },
         ],
         selected: this.form ? this.form : []
      }
   },
   computed: {
      rdsUsers: function () {
         return this.companyUsers() ? this.companyUsers().filter(user => user.username) : []
      },

      getRdsUserCount () {
         return this.rdsUserCount()
      }
   },
   watch: {
      selected: {
         deep: true,
         handler (val, oldVal) {
            this.$emit('update:form', this.selected)
         }
      }
   },
   created () {
      this.selected = this.form.filter(
         selected => this.rdsUsers.find(user => user.username === selected.username)
      )
   },
   methods: {
      branchname (id) {
         const branch = this.branchItems().find(elem => elem.value === parseInt(id))
         return branch ? branch.text.split('|')[0] : ''
      }
   }
}
</script>

<style>

</style>
